// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"wq-z","slideIn":"xq-z"};